<template>
    <b-row>
        <b-col cols="12">
            <b-row>
                <b-col cols="10">
                    <b-form-input
                        v-model="search"
                        type="text"
                        placeholder="Buscar por email, nombre, apellidos o teléfono"
                        class="mb-2"
                        debounce="300"
                        @update="getSubscriptores"
                        cols="6"
                    />
                </b-col>
                <b-col cols="2">
                    <div class="d-flex justify-content-end">
                        <button 
                            class="btn btn-primary mt-4" 
                            @click="openAnadirSubscriptorModal"
                            :disabled="loading"
                        >
                            Añadir subscriptor
                        </button>
                    </div>
                </b-col>
            </b-row>
        </b-col>
        <b-col cols="12" class="mt-3">
            <b-table hover :items="subscriptores.data" :fields="fields" :busy="loading">
                <template #cell(activo)="{ item }">
                    <span v-if="item.activo" class="mr-2"><i class="text-green fas fa-check-circle"></i></span>
                    <span v-else class="mr-2"><i class="text-danger fas fa-times-circle"></i></span>
                </template>
                <template #cell(opciones)="{ item, index }">
                    <OpcionesDropdownTableComponent 
                        :lastIndex="subscriptores.data.length > 3 && index >= subscriptores.data.length - 3"
                        :options="[
                            { to: { name: 'back.emails.subscriptores.show', params: { subscriptor_id: item.id } }, label: 'Ver'},
                            { type: 'action', action:() => $modal.show('desvincular-subscriptor-' + item.id), label: 'Desvincular' },
                        ]"
                    />
                    <ModalComponent
                        :name="'desvincular-subscriptor-' + item.id"
                        :title="'Desvincular subscriptor: ' + item.nombre"
                        @close="() => $modal.hide('desvincular-subscriptor-' + item.id)"
                    >
                        <div class="row">
                            <div class="col-12 text-center mb-3">
                                <h3>¿Está seguro que desea desvincular este subscriptor del grupo?</h3>
                            </div>
                            <div class="col-12 text-center">
                                <Button
                                    type="button"
                                    class="btn btn-primary mr-2"
                                    @click="descvinvularSubscriptor(item.id)"
                                    :disabled="loading"
                                >
                                    Desvincular Subscriptor
                                </Button>
                            </div>
                        </div>
                    </ModalComponent>
                </template>
            </b-table>
            <b-pagination
                align="center"
                v-if="subscriptores.meta"
                v-model="subscriptores.meta.current_page"
                :total-rows="subscriptores.meta.total"
                :per-page="subscriptores.meta.per_page"
                @page-click="pageClicked"
            />
        </b-col>
        <AnadirSubscriptorModal
            :grupo="grupo"
            :show="modal_anadir_subscriptor"
            @close="closeAnadirSubscriptorModal"
        />
    </b-row>

</template>

<script>
    import OpcionesDropdownTableComponent from '@/components/backend/components/OpcionesDropdownTableComponent.vue';
    import apiService from '@/services/api-comunicados';
    import ModalComponent from "../../../components/ModalComponent.vue";
    import AnadirSubscriptorModal from '@/components/backend/campana-emails/subscriptores/grupos/AnadirSubscriptorModal.vue';

    export default {
        props: {
            grupo: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                loading: false,
                subscriptores: {},
                fields: [
                    { key: "email", label: "Email", class: "text-center" },
                    { key: "nombre", label: "Nombre", class: "text-center" },
                    { key: "apellidos", label: "Apellidos", class: "text-center" },
                    { key: "telefono", label: "Teléfono", class: "text-center" },
                    { key: "activo", label: "Activo", class: "text-center" },
                    { key: "opciones", label: "opciones" }
                ],
                search: '',
                modal_anadir_subscriptor: false,
            }
        },
        mounted() {
            this.getSubscriptores();
        },

        methods: {
            async getSubscriptores(page = 1) {
                const filters = {
                    grupos_ids: [this.grupo.id],
                    search: this.search,
                    page: page
                }

                this.loading = true;
                try {
                    this.subscriptores = await apiService.getSubscriptores(filters);
                } catch (error) {
                    this.$toast.error('Error al obtener subscriptores', error);
                } finally {
                    this.loading = false;
                }
            },
            pageClicked(event, page) {
                this.getSubscriptores(page);
            },
            async descvinvularSubscriptor(subscriptorId) {
                this.loading = true;
                try {
                    await apiService.desvincularUsuarioDeGrupo(subscriptorId, this.grupo.id);
                    this.getSubscriptores();
                    this.$modal.hide('desvincular-subscriptor-' + subscriptorId);
                    this.$toast.success('Subscriptor desvinculado correctamente');
                } catch (error) {
                    console.error('Error al desvincular subscriptor', error);
                    this.$toast.error('Error al desvincular subscriptor');
                } finally {
                    this.loading = false;
                }
            },
            openAnadirSubscriptorModal() {
                this.modal_anadir_subscriptor = true;
                this.$modal.show('anadir-subscriptor-modal');
            },
            closeAnadirSubscriptorModal() {
                this.modal_anadir_subscriptor = false;
                this.$modal.hide('anadir-subscriptor-modal');
                this.getSubscriptores();
            }
        },
        components: {
            ModalComponent,
            OpcionesDropdownTableComponent,
            AnadirSubscriptorModal
        }
    }
</script>